// @flow
import React from "react";
import withStyles from "elevate-ui/withStyles";
import { withGlobalContext } from "../../../common/GlobalContext";
import Typography from "elevate-ui/Typography";
import Hr from "elevate-ui/Hr";
import Button from "elevate-ui/Button";
import HomeIcon from "elevate-ui-icons/Home";
import BackgroundSlider from "react-background-slider";

import HeaderSearch from "../HeaderSearch";

import type { $Agent, $SiteOffice, $Site, $Team } from "flow/types";

type $Props = {
  agent: $Agent,
  classes: Object,
  office: $SiteOffice,
  site: $Site,
  team: $Team,
  backgroundImage: string,
  backgroundImages?: Array<string>,
  isCanadian: Function,
};

const ExpandedSearchHalf = ({
  agent,
  site,
  team,
  office,
  classes,
  backgroundImage,
  backgroundImages,
  isCanadian,
}: $Props) => {
  const renderHeadline = (): string => {
    if (site.userId && agent) {
      // $FlowIgnore
      return agent.fullName;
    } else if (site.teamId && team) {
      return team.name;
    } else if (site.officeId && office) {
      return office.name;
    } else {
      return "";
    }
  };

  const innerPortion = (
    <div className={classes.podContainer}>
      <div className={classes.agentInfo}>
        <Typography type="heading2" color="#ffffff" style={{ marginBottom: 0 }}>
          {renderHeadline()}
        </Typography>
        {agent &&
          agent.title && (
            <Typography type="heading5" color="#fff" style={{ marginTop: "0" }}>
              {agent.title}
            </Typography>
          )}
        <Hr color="#fff" style={{ width: "250px" }} />
        <div className={classes.buttonGroup}>
          <Button element="a" href="/listings/featured" color="primary">
            Properties
          </Button>
          <Button element="a" href="/contact" color="#fff">
            Contact
          </Button>
        </div>
      </div>
      <div className={classes.searchContainer}>
        <div className={classes.searchHeader}>
          <Typography
            type="heading6"
            style={{ margin: 0, textTransform: "uppercase" }}
          >
            Search For Homes
          </Typography>
          <HomeIcon />
        </div>
        <div className={classes.searchBox}>
          <HeaderSearch
            showColorButtons={false}
            isCanadian={isCanadian()}
            initialFilterState="open"
            filterBackground="none"
            filterPosition="relative"
            hideFilterButton
            compact
          />
        </div>
      </div>
    </div>
  );

  if (backgroundImages && backgroundImages.length > 1) {
    return (
      <div className={classes.root}>
        <BackgroundSlider
          images={backgroundImages}
          duration={5}
          transition={2}
        />
        <div className={classes.backgroundImagesOverlay}>{innerPortion}</div>
      </div>
    );
  }

  return (
    <div
      className={classes.root}
      style={{
        background: `linear-gradient(rgba(20, 20, 20, 0.4), rgba(20, 20, 20, 0.4)), url(${backgroundImage}) center/cover no-repeat`,
      }}
    >
      {innerPortion}
    </div>
  );
};

const styles = (theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    minHeight: "60vh",
  },
  backgroundImagesOverlay: {
    backgroundColor: "#00000050",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    minHeight: "60vh",
  },
  podContainer: {
    display: "flex",
    flexFlow: "row nowrap",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    width: "100%",
    maxWidth: "1200px",
    padding: "12px 24px",
    [theme.breakpoints(900)]: {
      justifyContent: "space-between",
    },
  },
  buttonGroup: {
    "& > * + *": {
      marginLeft: theme.spacing.unit * 0.75,
    },
  },
  searchContainer: {
    flex: "0 0 100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "stretch",
    position: "relative",
    [theme.breakpoints(900)]: {
      flex: "0 0 290px",
    },
  },
  searchHeader: {
    display: "flex",
    flexFlow: "row nowrap",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "48px",
    padding: theme.spacing.unit * 0.75,
    backgroundColor: "white",
  },
  searchBox: {
    position: "relative",
    padding: "10px 10px 10px",
    backgroundColor: "rgba(255,255,255,.3)",
  },
  agentInfo: {
    display: "none",
    [theme.breakpoints(900)]: {
      display: "block",
    },
  },
});

export default withGlobalContext(withStyles(styles)(ExpandedSearchHalf));
